import { colors, cbSemanticCssVars, elevationCss } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { usePluralization } from 'common/hooks';
import { Typography as T } from 'common/typography';
import { solidify } from 'modules/menu/solidify';

type Props = {
  count: number;
};

const Root = styled.div`
  ${elevationCss(4)};
  display: flex;
  align-items: center;
  background-color: ${({ theme }) =>
    theme.cbThemeMode === 'dark' ? solidify(colors.salt12, 'dark') : solidify(colors.pepper8, 'light')};
  height: 105px;
`;

const FakeCheckbox = styled.div`
  display: block;
  width: 16px;
  height: 16px;
  margin-inline-start: 24px;
  border-radius: 2px;
  border: 1px solid ${cbSemanticCssVars.borderPrimary};
`;

const Content = styled(T.Heading6)`
  margin-inline-start: 16px;
`;

const ItemsDragLayer = ({ count }: Props) => {
  const { FormattedPluralMessage } = usePluralization();
  return (
    <Root>
      <FakeCheckbox />
      <Content>
        <FormattedPluralMessage id="picking-route.item-count" count={count} />
      </Content>
    </Root>
  );
};

export default ItemsDragLayer;
